import React, { Children } from 'react';
import { PropTypes } from 'prop-types';
import { Button, Divider, Grid } from '@nextiva/next-ui-components';

import { VERIFY_NEW_DOMAIN } from 'constants/drawerTitles';
import Drawer from 'containers/Drawer';

import styles from './VerifyDrawer.scss';

const VerifyDrawer = ({ children, open, toggleDrawer }) => {
  return (
    <Drawer
      title={VERIFY_NEW_DOMAIN}
      buttonStyle={styles.verifyDomainButton}
      {...{ open, toggleDrawer }}
    >
      {Children.map(children, (child, index) => {
        return (
          <div className={styles.verifyDrawerSection}>
            {index === 0 || <Divider />}
            {child}
          </div>
        );
      })}
      <div className={styles.footer}>
        <Grid container>
          <Grid className={styles.cancelButton} item xs={3}>
            <Button
              fullWidth
              color="secondary"
              variant="contained"
              onClick={toggleDrawer}
              data-testid="PlatformAdminUI-VerifyDrawer-CancelButton"
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

VerifyDrawer.propTypes = {
  toggleDrawer: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

VerifyDrawer.defaultProps = {
  open: false,
};

export default VerifyDrawer;
